import { render, staticRenderFns } from "./PriceIncreaseInPercentageInOriginalCurrencyComparedToAveragePriceIncrease.vue?vue&type=template&id=b60941ee&"
import script from "./PriceIncreaseInPercentageInOriginalCurrencyComparedToAveragePriceIncrease.vue?vue&type=script&lang=js&"
export * from "./PriceIncreaseInPercentageInOriginalCurrencyComparedToAveragePriceIncrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports